const LogIcon = () => {
    return (
        <svg
            width="37"
            height="40"
            viewBox="0 0 37 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
        <path 
            d="M3.5 40C2.66667 40 1.95833 39.7083 1.375 39.125C0.79167 38.5417 0.5 37.8333 0.5 37V7C0.5 6.16667 0.79167 5.45833 1.375 4.875C1.95833 4.29167 2.66667 4 3.5 4H13.75C13.9167 2.83333 14.45 1.875 15.35 1.125C16.25 0.375 17.3 0 18.5 0C19.7 0 20.75 0.375 21.65 1.125C22.55 1.875 23.0833 2.83333 23.25 4H33.5C34.3333 4 35.0417 4.29167 35.625 4.875C36.2083 5.45833 36.5 6.16667 36.5 7V37C36.5 37.8333 36.2083 38.5417 35.625 39.125C35.0417 39.7083 34.3333 40 33.5 40H3.5ZM3.5 37H33.5V7H3.5V37ZM8.5 32H22.15V29H8.5V32ZM8.5 23.5H28.5V20.5H8.5V23.5ZM8.5 15H28.5V12H8.5V15ZM18.5 6.15C18.9667 6.15 19.375 5.975 19.725 5.625C20.075 5.275 20.25 4.86667 20.25 4.4C20.25 3.93333 20.075 3.525 19.725 3.175C19.375 2.825 18.9667 2.65 18.5 2.65C18.0333 2.65 17.625 2.825 17.275 3.175C16.925 3.525 16.75 3.93333 16.75 4.4C16.75 4.86667 16.925 5.275 17.275 5.625C17.625 5.975 18.0333 6.15 18.5 6.15Z"
            fill="#64648C"
        />
        </svg>
    );
  };
  
  export default LogIcon;